import {styled} from "@mui/material";

export const ChangePasswordContainer = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '1rem'
    }
});
